/* eslint-disable no-unreachable */
/* eslint-disable prettier/prettier */
/* eslint-disable consistent-return */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-template */
/* eslint-disable camelcase */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import useTweets from '../../../hooks/useTweets';
import TweetInput from './TweetInput';
import { toast } from 'react-toastify';
import getQuote from 'utils/quoteService';
import imageToBase64 from 'image-to-base64/browser';
import axios from 'axios';
import TweetsyConfig from 'TweetsyConfig';
import useAuth from 'hooks/useAuth';

const TweetInputs = () => {
    const theme = useTheme();
    const { idMemorized, setIdMemorized, scheduleInputs, setScheduleInputs } = useTweets();
    const dateTimeRef = useRef();
    const { dbUser } = useAuth();
    const [isScheduling, setIsScheduling] = useState(false)


    useEffect(() => {
        console.log('scheduleInputs:- ', scheduleInputs);
    }, []);


    const handleScheduleSubmit = e => {
        e.preventDefault();


        // eslint-disable-next-line no-underscore-dangle
        console.log('🧪 dbuser', dbUser._id)

        // return;



        if (!dateTimeRef.current) return;

        console.log("Submit ❤")
        console.log('🧪 schedule\n', scheduleInputs)
        console.log('🧪 Time', dateTimeRef.current.value)

        const currentMS = new Date().valueOf();
        const selectedDate = new Date(dateTimeRef.current.value).valueOf()
        console.log('🧪 Time compare \n', currentMS, '\n', selectedDate)

        if (selectedDate - currentMS < 60000) {
            toast('Selected time should be at Least 1 Minute Later than Present Time', {
                autoClose: 3000,
                type: "warning"

            })

            return;
        }
        console.log('🧪 posteable')

        // eslint-disable-next-line prefer-const
        let texts = []
        scheduleInputs.forEach(item => {
            // console.log(item)
            if (!item.text) return;

            const { text, img } = item;

            // eslint-disable-next-line prefer-const
            let tweet = { text }
            if (!img) return texts.push(tweet)

            tweet.options = { media_data: img.base64 }
            return texts.push(tweet)
        })

        if (!texts.length) return; // return if empty!

        // console.log(texts)

        const dateTimeGMT = new Date(dateTimeRef.current.value).toGMTString();
        const dateTimeMS = new Date(dateTimeGMT).valueOf()
        // console.log(dateTimeGMT)

        const thread = { texts, dateTimeGMT, dateTimeMS }
        console.log(thread);

        setIsScheduling(true)
        // eslint-disable-next-line no-underscore-dangle
        axios.post(`${TweetsyConfig.getNodeUrl()}TweetThread/${dbUser._id}`, thread)
            .then(res => {
                console.log(res.data);
                // show toast
                // toast(`${texts.length = 1 ? 'Tweet' : 'Thread'} scheduled successfully.`, {
                toast(`Tweet scheduled successfully.`, {
                    autoClose: 3000,
                    type: "success"
                })
                // clear state
                setScheduleInputs([{ id: 0, text: '' }]);
                dateTimeRef.current.value = null;

            }).catch(err => {
                console.log(err);
                // show toast
                toast('Something went wromg.! please try again.', {
                    autoClose: 3000,
                    type: "error"

                })
            }).finally(() => {
                setIsScheduling(false)
            })
    }



    const addInput = (index) => {
        console.log('add after:', index);
        setScheduleInputs((val) => [...val.slice(0, index + 1), { id: idMemorized, text: '' }, ...val.slice(index + 1)]);
        setIdMemorized(idMemorized + 1);
    };
    const removeInput = (index) => {
        console.log('remove:', index);
        if (index == 0) return setScheduleInputs((val) => [...val.slice(1)]);
        setScheduleInputs((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    };

    const handleOnCahange = (index, text) => {
        // console.log('onChange index: ', index)

        setScheduleInputs((val) => {
            // eslint-disable-next-line prefer-const
            let copy = [...val];
            const changes = val[index];
            changes.text = text;
            copy[index] = changes;

            return copy;
        });
    };

    const handleImojiClick = (emojiObject, index, setShowImojiPicker) => {
        // setCoppiedTweet(prevInp => prevInp + emojiObject.emoji);
        setScheduleInputs((val) => {
            // eslint-disable-next-line prefer-const
            let copy = [...val];
            const changes = val[index];
            changes.text += emojiObject.emoji;
            copy[index] = changes;

            return copy;
        });

        setShowImojiPicker(false);
    };

    const handleImgOnChange = (index, e) => {
        const img = e.target.files[0];
        console.log('img from index:', index);

        if (!img) return;
        console.log('image found:', img);
        const url = URL.createObjectURL(img);

        imageToBase64(url) // Image URL
            .then((res) => {
                // console.log('img base64: ', res);
                const base64 = res;
                setScheduleInputs((val) => {
                    // eslint-disable-next-line prefer-const
                    let copy = [...val];
                    const changes = val[index];
                    changes.img = {
                        file: img,
                        base64,
                        url
                    };
                    copy[index] = changes;

                    return copy;
                });
            })
            .catch((err) => {
                console.log('error on img convert:', err);
            })
            // eslint-disable-next-line no-return-assign
            .finally(() => (e.target.value = null));
    };

    // for quote
    const handleQuoteBtn = (index) => {
        // Toastify- show loading toast
        const loadingOrders = toast.loading('Generating Quote....');

        getQuote()
            .then(function (response) {
                const { quote_text, author } = response.data[0];
                // console.log(quote_text + '/n' + author)

                setScheduleInputs((val) => {
                    // eslint-disable-next-line prefer-const
                    let copy = [...val];
                    const changes = val[index];
                    changes.text = quote_text + '\n-' + author;
                    copy[index] = changes;

                    return copy;
                });
                toast.update(loadingOrders, {
                    render: 'Quote generated',
                    type: 'success',
                    isLoading: false,
                    autoClose: 1000
                });
            })
            .catch(function (error) {
                console.error(error);
                toast.update(loadingOrders, {
                    render: 'Failed! Please try again.',
                    type: 'error',
                    isLoading: false,
                    autoClose: 1000
                });
            });
    };

    return (
        <Box
            sx={{
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                p: 0,
                borderRadius: 2
            }}
        >
            <form onSubmit={handleScheduleSubmit}>
                {/* All inputs */}
                {scheduleInputs.map((val, index) => (
                    <TweetInput
                        key={val.id}
                        length={scheduleInputs.length}
                        {...{ val, index, addInput, removeInput, handleOnCahange, handleImgOnChange, handleQuoteBtn, handleImojiClick }}
                    />
                ))}

                {/* time Input */}
                <input
                    type="datetime-local"
                    ref={dateTimeRef}
                    required
                    style={{
                        fontFamily: 'Roboto',
                        fontSize: '16px',
                        border: `1px solid ${theme.palette.grey[500]}`,
                        padding: '2px 5px',
                        borderRadius: '5px',
                        color: theme.palette.grey[500],
                        background: 'transparent'
                    }}
                />
                <br />
                <br />
                <Button disabled={isScheduling} variant="contained" type="submit">
                    {isScheduling ? 'Scheduling...' : 'Schedule'}
                </Button>
            </form>
        </Box>
    );
};

export default TweetInputs;
